export default __webpack_public_path__ + "static/media/poster 3.26bd5ce0.jpg";